
import React, { useState, useContext, Fragment } from "react";
import { useAuth } from "../hooks/AuthProvider";
import { useNavigate, useLocation } from "react-router-dom";
import '../Pages/Signup.css';
import Logo from "../assets/image/logoo.png";

import Alert from '../Components/Alert';
import { LanguageContext } from '../context/LanguageContext';
import authTranslations from '../languages/auth.json';
import signup from "../assets/image/65214547de2a3ff968379537926d89705ec4f0a1.png"

const EmailIcon = ({ className }) => (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
);
const KeyIcon = ({ className }) => (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="15" r="4"></circle><path d="M14.5 9c-1.76-1.57-4.24-1.57-6 0"></path></svg>
);
const ChevronLeft = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
);

export const VerifyResetCode = () => {
    const { lang } = useContext(LanguageContext);
    const tRoot = authTranslations[lang] || authTranslations.en;
    const t = tRoot.VerifyResetCode;

    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuth();
    const isRtl = ['ar', 'ur'].includes(lang);

    const initialEmail = location.state?.email || '';

    const [email, setEmail] = useState(initialEmail);
    const [code, setCode] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const [emailError, setEmailError] = useState("");
    const [codeError, setCodeError] = useState("");

    const [alertState, setAlertState] = useState({
        open: false,
        message: '',
        type: 'info',
        position: isRtl ? 'left' : 'right',
    });

    const showAlert = (type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
    };

    const onFormSubmit = async (e) => {
        e.preventDefault();
        setEmailError("");
        setCodeError("");
        const normalizedEmail = String(email || "").trim();
        const normalizedCode = String(code || "").trim();

        let isValid = true;

        if (!normalizedEmail) {
            setEmailError(t.errorRequiredEmail);
            isValid = false;
        }
        if (!normalizedCode) {
            setCodeError(t.errorRequiredCode);
            isValid = false;
        }

        if (!isValid) return;

        setSubmitting(true);
        try {
            await auth.verifyResetCodeAction(normalizedEmail, normalizedCode);
            showAlert('success', t.successMessage);
            navigate('/reset-password', { replace: true });
        } catch (error) {
            showAlert('error', error?.message || t.failureMessage);
        } finally {
            setSubmitting(false);
        }
    };

    const goBack = () => {
        navigate(-1);
    };

    return (
        <Fragment>
            <Alert
                open={alertState.open}
                close={() => setAlertState({ ...alertState, open: false })}
                message={alertState.message}
                type={alertState.type}
                position={alertState.position}
            />

            <div className="auth-page-wrapper">

                <div className="verefy-header">
                    <img src={Logo} alt="Sama-IOT Logo" className="auth-brand-logo" />
                    <span className="auth-brand-name">Sama-IOT</span>
                </div>

                <div className="signup-card-center">
                    <div className="signup-main-card">
                        <div className="signup-form-area">

                            <button className="signup-back-button" onClick={goBack}>
                                <ChevronLeft />
                                {t.buttonBack}
                            </button>

                            <div className="verefy-header-text">
                                <h2>{t.title}</h2>
                            </div>

                            <p className="signup-instruction-text">
                                {t.instructionText}
                            </p>

                            <form onSubmit={onFormSubmit}>

                                <div className="auth-form-group">
                                    <label htmlFor="auth-email">
                                        <EmailIcon className="auth-label-icon" />
                                        {t.labelEmail}
                                    </label>
                                    <div className={`auth-input-wrapper ${emailError ? 'has-error' : ''}`}>
                                        <input
                                            id="auth-email"
                                            value={email}
                                            type="email"
                                            name="email"
                                            placeholder={t.placeholderEmail}
                                            onChange={ev => setEmail(ev.target.value)}
                                            required
                                            disabled={submitting || Boolean(initialEmail)}
                                            className="auth-form-input"
                                        />
                                    </div>
                                    {emailError && <span className="auth-error-message">{emailError}</span>}
                                </div>

                                <div className="auth-form-group">
                                    <label htmlFor="auth-code">
                                        <KeyIcon className="auth-label-icon" />
                                        {t.labelCode}
                                    </label>
                                    <div className={`auth-input-wrapper ${codeError ? 'has-error' : ''}`}>
                                        <input
                                            id="auth-code"
                                            value={code}
                                            type="text"
                                            name="code"
                                            placeholder={t.placeholderCode}
                                            onChange={ev => setCode(ev.target.value)}
                                            required
                                            className="auth-form-input"
                                            disabled={submitting}
                                        />
                                    </div>
                                    {codeError && <span className="auth-error-message">{codeError}</span>}
                                </div>

                                <button
                                    className="auth-submit-btn"
                                    type="submit"
                                    disabled={submitting}
                                >
                                    {submitting ? t.buttonVerifying : t.buttonVerify}
                                </button>

                            </form>
                        </div>

                        <div className="signup-image-area">
                            <img
                                src={signup}
                                alt="Verify Email Illustration"
                                className="signup-illustration"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
};
